<div class="d-flex h-100 w-100">
  <div class="w-100 content-main">
    <ng-container *ngIf="showEdit">
      <div class="d-flex al-center">
        <div class="d-flex al-center pointer" (click)="goTo()">
          <img src="assets/svg/Icon_back.svg" class="me-3" alt="">
          <span class="fw-bold fs-5">Atrás</span>
        </div>
      </div>
      <br>
      <form [formGroup]="headQuestionForm">
        <div class="bg-white py-4 px-5 rounded shadow-sm">
          <ng-container *ngIf="rol==1">
            <div class="d-flex sp-between al-center mb-2">
              <div>
                <span class="fs-6 fw-bold text-black">Título del {{ page == 'entrenamiento' ? 'exámen':'producto' }}</span>
              </div>
              <div *ngIf="isProduct && itemId > 0">
                <span class="fw-regular fs-7 text-secondary pointer" (click)="dialogDelete()">Eliminar producto</span>
              </div>
            </div>
            <div>
              <input type="text" formControlName="title" maxlength="50" class="w-100 border rounded px-3" [ngClass]="isDisabledHead ? 'disabled':''" [readOnly]="isDisabledHead">
            </div>
            <br>
            <div class="mb-2">
              <span class="fs-6 fw-bold text-black">{{ page == 'entrenamiento' ? 'Instrucciones para el examen':'Descripción del producto' }}</span>
            </div>
            <div>
              <textarea type="text" formControlName="instructions" maxlength="200" class="w-100 border rounded p-3" [ngClass]="isDisabledHead ? 'disabled':''" rows="3" [readOnly]="isDisabledHead"></textarea>
            </div>
            <br>
            <div class="text-end">
              <button mat-flat-button class="bg-blue-2 btn-action" (click)="isDisabledHead ? isDisabledHead = !isDisabledHead : saveHeadQuestion()">
                <span class="fw-bold fs-5 text-white me-3">{{ isDisabledHead ? 'Editar':'Guardar' }} cambios</span>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="rol == 3">
            <div>
              <span class="fs-6 fw-bold">{{ this.headQuestionForm.value.title }}</span>
            </div>
            <div>
              <span class="fs-6 fw-regular">{{ this.headQuestionForm.value.instructions }}</span>
            </div>
          </ng-container>
        </div>
      </form>
      <br><br>
      <div>
        <span class="fw-bold fs-5">Datos del {{ page == 'entrenamiento' ? 'exámen':'producto' }}</span>
      </div>
      <div *ngIf="rol==1">
        <span class="fs-6 text-secondary fw-regular"> {{ page == 'entrenamiento' ? 'Aquí podrás crear las preguntas del examen.'
          :'Aquí se muestran los campos obligatorios que se debe completar para este producto.' }} </span>
      </div>
      <br>
    </ng-container>
    <div *ngFor="let question of questionsList; let i = index">
      <div class="bg-white p-5 rounded shadow-sm">
        <div *ngIf="rol==1">
          <div class="mb-3">
            <span class="text-black">Ingrese pregunta</span>
          </div>
          <div>
            <input type="text" [(ngModel)]="question.pregunta" class="w-100 border rounded px-3" [ngClass]="question.disabled ? 'disabled':''" [readOnly]="question.disabled">
          </div>
          <ng-container *ngIf="question.tipo_pregunta_id != 1">
            <br>
            <div class="mb-3">
              <span>Ingrese {{ question.tipo_pregunta_id == 2 ? 'opciones de la lista desplegable' :
                question.tipo_pregunta_id == 3 ?
                'las opciones múltiples' : 'las opciones de las casillas de verificación' }} que mostrará.</span>
            </div>
            <div class="d-flex al-center w-100 mb-4" *ngFor="let item of question.opciones; let i = index">
              <div class="content-option">
                <span>Opción {{i+1}}</span>
              </div>
              <div class="w-100">
                <input type="text" [(ngModel)]="item.value" [placeholder]="'Escriba opción '+ (i+1)" [ngClass]="question.disabled ? 'disabled':''" [readOnly]="question.disabled" class="w-100 border rounded px-3">
              </div>
            </div>
            <div class="text-end" *ngIf="!question.disabled">
              <button mat-fab style="background-color: #0A3245;" (click)="addOption(question)">
                <span class="fs-1">+</span>
              </button>
            </div>
            <br>
          </ng-container>
          <br>
          <div class="d-flex gap al-center sp-end mt-2">
            <ng-container *ngIf="question.pregunta_id > 0">
              <button mat-flat-button class="bg-blue btn-action" (click)="deleteQuestion(question)">
                <span class="fw-bold fs-5 text-white me-3">Eliminar pregunta</span>
              </button>
            </ng-container>
            <button mat-flat-button class="bg-blue-2 btn-action" (click)=" !question.disabled ? saveQuestion(question) : question.disabled  = !question.disabled ">
              <span class="fw-bold fs-5 text-white me-3">{{question.disabled ? 'Editar':'Guardar'}} cambios</span>
            </button>
          </div>
        </div>
        <div *ngIf="rol == 3">
          <div class="mb-2">
            <span class="fw-bold fs-5">Pregunta</span>
          </div>
          <div class="mb-3">
            <span class="fw-regular fs-6">{{i+1}}. {{question.pregunta}}</span>
          </div>
          <ng-container *ngIf="question.tipo_pregunta_id != 1">
            <div class="mb-2">
              <span class="fs-6 fw-bold">Estas son las opciones disponibles.</span>
            </div>
          </ng-container>
          <ng-container *ngIf="question.tipo_pregunta_id == 1">
            <div >
              <input type="text" [(ngModel)]="question.answer" placeholder="Ingrese respuesta" class="w-100 border rounded px-3">
            </div>
          </ng-container>
          <ng-container *ngIf="question.tipo_pregunta_id == 2">
            <div class="border rounded">
              <nz-select class="w-100" nzPlaceHolder="Seleccione una opción" [(ngModel)]="question.answer">
                <nz-option [nzValue]="al.id" [nzLabel]="al.value" *ngFor="let al of question.opciones"></nz-option>
              </nz-select>
            </div>
          </ng-container>
          <ng-container *ngIf="question.tipo_pregunta_id == 3">
            <nz-radio-group class="d-flex flex-column gap" [(ngModel)]="question.answer">
              <label nz-radio [nzValue]="al.id" *ngFor="let al of question.opciones">{{al.value}}</label>
            </nz-radio-group>
          </ng-container>
          <ng-container *ngIf="question.tipo_pregunta_id == 4">
            <div class="d-flex flex-column gap">
                <label nz-checkbox [ngModel]="al.checked" class="mx-0 fs-6" [ngModelOptions]="{standalone: true}" (ngModelChange)="al.checked = !al.checked" *ngFor="let al of question.opciones">{{al.value}}</label>
            </div>
          </ng-container>
        </div>
      </div>
      <br>
    </div>
    <ng-container *ngIf="rol == 3 && showEdit">
      <div class="text-end mb-3">
        <button mat-flat-button class="bg-blue-2 btn-action" (click)="registerQuestions()">
          <span class="fw-bold fs-5 text-white">Terminar exámen</span>
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="rol==1">
      <div class="bg-white p-5">
        <div class="d-flex al-center sp-center flex-column">
          <div>
            <span>Ingrese nuevo campo</span>
          </div>
          <div class="mt-4">
            <button mat-fab style="background-color: #0A3245;" (click)="showDialogForm()">
              <span class="fs-1">+</span>
            </button>
          </div>
        </div>
      </div>
      <br>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>